export default __webpack_public_path__ + "static/media/card-m-review.75563e97.png";